import { render, staticRenderFns } from "./HouseBuildingSelectbox.vue?vue&type=template&id=40165ffb&"
import script from "./HouseBuildingSelectbox.vue?vue&type=script&lang=js&"
export * from "./HouseBuildingSelectbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports